module.exports = __webpack_public_path__ + "static/media/unnamed-1.330a5c96.jpg";